import { Divider } from 'antd';

const Koate = () => {
  return (
    <>
      <div className="bg-[#f3f3f3] p-4 md:p-8 pt-4 rounded-md">
        <Divider />
        <p className="m-2 font-bold">Approved Use</p>

        <p className="m-2">
          KOĀTE (Antihemophilic Factor (Human)) is a medicine used for the control and prevention of
          bleeding episodes or in order to perform emergency and elective surgery in patients with
          hemophilia A (hereditary Factor VIII deficiency). KOĀTE is not approved for the treatment
          of von Willebrand disease.
        </p>

        <p className="m-2 font-bold">Important Safety Information</p>

        <p className="m-2">
          Do not use KOĀTE if you have had an allergic reaction to KOĀTE or any of its components.
        </p>

        <p className="m-2">
          Tell your healthcare provider about all of your medical conditions, including any
          medicines you take, including prescription and non-prescription medicines, such as
          over-the-counter medicines, supplements or herbal remedies.
        </p>

        <p className="m-2">
          Allergic reactions, including serious, life-threatening allergic reactions, are possible
          from the administration of antihemophilic factor preparations such as KOĀTE. Immediately
          report any of the following signs or symptoms of an allergic reaction to your healthcare
          provider: swelling of the throat, tightness of the chest, low blood pressure, rash,
          nausea, vomiting, a tingling or pricking sensation, restlessness, wheezing or shortness of
          breath.
        </p>

        <p className="m-2">
          Antibodies neutralizing Factor VIII (also known as inhibitors), which can make the product
          less effective or ineffective, may form with use of KOĀTE. Your healthcare provider will
          monitor you for the development of inhibitors.
        </p>

        <p className="m-2">
          There is a risk of increased breakdown of red blood cells (or hemolytic anemia) in
          patients with blood groups A, B or AB when large or frequent doses of KOĀTE are given.
          Your healthcare provider will monitor your levels of red blood cells and look out for
          signs of red blood cell breakdown.
        </p>

        <p className="m-2">
          KOĀTE is made from human blood and, therefore, carries a risk of transmitting infectious
          agents, such as viruses, the agent of the variant Creutzfeldt-Jakob disease (vCJD), or
          unknown infectious agents. You should consult with your healthcare provider if you have
          any questions or concerns.
        </p>

        <p className="m-2">
          In a clinical study, the most common side effects associated with the infusion of KOĀTE
          were nervousness, headache, abdominal pain (stomach ache), nausea, tingling sensation and
          blurred vision.
        </p>

        <div>
          <p className="m-2">
            <b>
              Please see&nbsp;
              <a
                target="_blank"
                href="/KOATE-Prescribing-Information.pdf"
                className="text-blue-500 hover:underline"
              >
                KOĀTE full Prescribing Information
              </a>
              &nbsp;for complete prescribing details.
            </b>
          </p>
          <p className="m-2">
            <b>
              You are encouraged to report negative side effects of prescription drugs to the FDA.
              Visit&nbsp;
              <a
                target="_blank"
                href="http://www.fda.gov/medwatch"
                className="text-blue-500 hover:underline"
              >
                www.fda.gov/medwatch
              </a>
              &nbsp;or call 1-800-FDA-1088.
            </b>
          </p>
        </div>
      </div>
    </>
  );
};

export default Koate;
